/** Вибро только в Telegram Mini App. Safari — тишина, тост снаружи. */

type TgHaptic = {
  impactOccurred?: (style: 'light' | 'medium' | 'heavy') => void;
  notificationOccurred?: (type: 'error' | 'success' | 'warning') => void;
};

function haptic(): TgHaptic | null {
  const tg = (window as unknown as { Telegram?: { WebApp?: { HapticFeedback?: TgHaptic } } })
    .Telegram?.WebApp?.HapticFeedback;
  return tg ?? null;
}

export function bumpCopy(): void {
  haptic()?.impactOccurred?.('light');
}

export function bumpDoor(): void {
  haptic()?.notificationOccurred?.('success');
}

export function bumpFail(): void {
  haptic()?.notificationOccurred?.('error');
}
